import React from 'react';
import ErrorMessage from './ErrorMessage';
import LoadingIcon from './LoadingIcon';

class CaspianImage extends React.Component 
{

    static defaultProps =
        {
            enlargementEnabled: true,
            fileName: "",
            loading: true,
        };

    constructor (props) 
    {
        super(props);
        this.state =
        {
            image: null,
            large: null
        };
    }

    componentDidMount () 
    {
        this.props.src()
            .then(result =>
            {
                if (result.error)
                {
                    ErrorMessage.SetErrorMessage(result.error);
                    this.setState({ loading: false });
                }
                else this.setState({ image: URL.createObjectURL(result) });
            })
            .catch(() =>
            {
                ErrorMessage.SetErrorMessage("Error! ErrorCode: CI28");
                this.setState({ loading: false });
            });
    }

    enlargement ()
    {
        this.setState({
            large:
                <div className="outsideOfCaspianImage">
                    <div
                        className={"topOfCaspianImage"}
                        onClick={() => this.setState({ large: null })}
                    >
                        <img
                            src={this.state.image}
                            alt={this.props.alt}
                            className={"largeImage pointer"}
                            onClick={() => this.setState({ large: null })}
                        />
                    </div>
                </div>
        });
    }

    render ()
    {
        if (this.state.image === null || this.props.fileName == null) return (<LoadingIcon loading={this.state.loading} />);
        if (this.props.fileName.endsWith(".jpg") || this.props.fileName.endsWith(".jpeg") || this.props.fileName.endsWith(".png"))
        {
            return (
                <div>
                    <img
                        src={this.state.image}
                        alt={this.props.alt}
                        className={this.props.className + this.props.enlargementEnabled ? " pointer" : ""}
                        onClick={this.props.enlargementEnabled ? this.enlargement.bind(this) : null}
                        style={this.props.style}
                    />
                    {this.state.large}
                </div>
            );
        }

        if (this.props.fileName.endsWith(".pdf"))
        {
            return (
                <div className='h-100 w-100'>
                    <div>
                        <a
                            href={this.state.image}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Open on a new tab
                        </a>
                    </div>
                    <div className='h-100 w-100'>
                        <iframe
                            src={this.state.image}
                            className='h-100 w-100'
                            title="invoicepreview"
                        />
                    </div>
                </div>
            );
        }

        return (
            <div>
                <p>
                    <a
                        href={this.state.image}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Open on a new tab
                    </a>
                </p>
                <p
                    className="link"
                    onClick={() =>
                    {
                        const tempLink = document.createElement('a');
                        tempLink.href = this.state.image;
                        tempLink.setAttribute('download', this.props.fileName);
                        //alert(this.props.fileName);
                        tempLink.click();
                    }}
                >
                    Download Invoice
                </p>
            </div>
        );
    }
}


export default CaspianImage;
